import { Segment } from './segment';

export class SegmentOperationFlowSelection {
  segmentId: number;
  operationId: number[];
  segment?: Segment;
}
